import React, {useEffect, useState} from 'react'
import actions from 'redux-auto'
import Button from '#components/a/Button'
import i18n from 'i18next'
import {hasNotSetTrackingPreference} from '#services/storage'
import Scrollbar from 'react-scrollbars-custom'

export default function CookieBanner() {
  const [showCookieBanner, setShowCookieBanner] = useState(false)

  useEffect(() => {
    setShowCookieBanner(hasNotSetTrackingPreference())
  }, [])

  const acceptAll = () => {
    actions.settings.setTrackingDisabled({trackingDisabled: false})
    setShowCookieBanner(false)
  }

  const acceptNecessary = () => {
    actions.settings.setTrackingDisabled({trackingDisabled: true})
    setShowCookieBanner(false)
  }

  if (!showCookieBanner) {
    return null
  }

  return (
    <div className="cookie-banner-overlay">
      <Scrollbar>
        <div class="cookie-banner-wrapper">
          <div className="cookie-banner">
            <div className="cookie-banner-content col-sm-10 col-md-8 col-lg-6">
              <div className="text">
                {i18n.t('cookie_banner_text_part_one')}
                <a href={i18n.t('cookie_banner_at_internet_link_url')} target={'at_internet'}>
                  {i18n.t('cookie_banner_at_internet_link_text')}
                </a>
                {i18n.t('cookie_banner_text_part_two')}
                <a href={i18n.t('cookie_banner_privacy_policy_link_url')} target={'privacy_policy'}>
                  {i18n.t('cookie_banner_privacy_policy_link_text')}
                </a>
                {i18n.t('cookie_banner_text_part_three')}
              </div>

              <div className="cookie-banner-actions">
                <Button
                  modifiers={['fullwidth']}
                  variant="secondary"
                  type="reset"
                  text={i18n.t('cookie_banner_accept_necessary')}
                  event={acceptNecessary}
                />
                <Button
                  modifiers={['fullwidth']}
                  variant="primary"
                  type="submit"
                  text={i18n.t('cookie_banner_accept_all')}
                  event={acceptAll}
                />
              </div>
            </div>
          </div>
        </div>
      </Scrollbar>
    </div>
  )
}
